import { ApiCore } from './utilities/core'


export const scoreCardActivityAPI = (tenantSlug: string) => {
    return new ApiCore({
        getAll: true,
        getSingle: true,
        post: true,
        patch: true,
        put: true,
        url: `api/${tenantSlug}/scorecard-activity`
    })
};